module.exports = __webpack_public_path__ + "img/model_47_zh.d266e8b9.jpg";